import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.lootbox.box,
    props.lootbox.buttons.prize_redeem,
    props.lootbox.buttons.prize_sell,
    (box, redeem, sell) => {
        return {
            box,
            buttons: {
                redeem,
                sell
            }
        }
    }
)